<article class="agreement-block text-gray-800 leading-relaxed">
  <header class="text-center mb-8">
    <p class="font-bold text-lg">ATTACHMENT B-1</p>
    <p class="font-bold mt-3">OPTIONS PRICE REPORTING AUTHORITY</p>
    <p class="font-bold mt-3">ELECTRONIC FORM OF<br>SUBSCRIBER AGREEMENT</p>
  </header>

  <p class="mb-4 font-semibold">
    IMPORTANT NOTICE: THIS SUBSCRIBER AGREEMENT (THIS &ldquo;AGREEMENT&rdquo;) IS AN AGREEMENT
    BETWEEN YOU AND {{ vendorName | uppercase }} FOR YOU TO RECEIVE INFORMATION PUBLISHED
    BY THE OPTIONS PRICE REPORTING AUTHORITY, LLC (&ldquo;OPRA&rdquo;). PLEASE READ THIS
    AGREEMENT CAREFULLY. AFTER YOU HAVE READ THIS AGREEMENT, PLEASE INDICATE YOUR
    AGREEMENT TO BE BOUND BY ITS TERMS AND CONDITIONS BY CLICKING ON THE
    &ldquo;I AGREE&rdquo; BUTTON AT THE END. IF YOU DO NOT AGREE TO THESE TERMS AND
    CONDITIONS, YOU WILL BE UNABLE TO RECEIVE THE INFORMATION.
  </p>

  <p class="mb-4">
    By completing and submitting this Agreement, you are applying to receive from
    <strong>{{ vendorName }}</strong> (email: <a [href]="'mailto:' + contactEmail" class="text-blue-600 hover:underline">{{ contactEmail }}</a>)
    (&ldquo;Vendor&rdquo;) a market data service (the &ldquo;Service&rdquo;) providing access to
    current options last sale and quotation information and related information
    (&ldquo;OPRA Data&rdquo;) published by OPRA pursuant to a Plan declared effective by the
    Securities and Exchange Commission. The parties to this Plan (each, an &ldquo;OPRA
    Participant&rdquo;) are those national securities exchanges that are from time to time
    approved by the Securities and Exchange Commission for the trading of securities
    options. In reviewing and approving this Agreement, Vendor is authorized to act on
    behalf of OPRA. The person who acts from time to time as data processor on behalf
    of OPRA is referred to herein as &ldquo;OPRA&rsquo;s Processor.&rdquo;
  </p>

  <p class="mb-4">
    By completing and submitting this Agreement and clicking on the &ldquo;I agree&rdquo;
    button at the end of this Agreement, you are consenting to enter into this Agreement
    in electronic form. You have the right to withdraw your consent by terminating this
    Agreement and your receipt of the OPRA Data. Your right to terminate this Agreement
    and your receipt of the OPRA Data, and the procedure you must follow to do so, are
    described in paragraph 6 below. If any information needed to contact you
    electronically changes, the procedure for notifying Vendor is described in paragraph
    11 below. If you wish to have a copy of this Agreement in paper form and you are
    unable to print a copy on your own computer system, Vendor will provide you with a
    paper copy at no charge upon its receipt of your request transmitted as described in
    paragraph 11. You may access a copy of this Agreement electronically at no charge,
    if your access to OPRA Data is from a device capable of receiving text, by navigating
    to <a [href]="'https://' + selfServiceUrl" target="_blank" rel="noopener" class="text-blue-600 hover:underline">{{ selfServiceUrl }}</a>
    and logging in with your provided username and password.
  </p>

  <p class="mb-4">
    This Agreement includes an &ldquo;Addendum for Nonprofessionals.&rdquo; The term
    &ldquo;Nonprofessional&rdquo; is defined in the Addendum. The purpose of the Addendum
    is to determine whether you are a Nonprofessional under this definition. If you are a
    Nonprofessional under this definition, OPRA&rsquo;s charges to Vendor for your use of
    the OPRA Data are subject to a cap, and you may be entitled to pay lower fees to
    Vendor. You do not need to complete the Addendum, but if you do not do so, or if you
    cannot agree with all of the statements in the Addendum, OPRA will not consider you
    to be a Nonprofessional.
  </p>

  <p class="mb-4">You hereby represent and agree as follows:</p>

  <ol class="list-decimal pl-8 space-y-4 mb-4">
    <li>Your full name and address are provided and accurate.</li>
    <li>
      You shall receive the Service and the OPRA Data included therein solely for your
      own business or personal use, and you shall not retransmit or otherwise furnish the
      OPRA Data to any person, other than your own employees on devices that are
      subject to the control of Vendor. If you are a Nonprofessional and have completed
      the Addendum for Nonprofessionals, you are only permitted under this Agreement to
      use the OPRA Data for the investment activities described in the Addendum for
      Nonprofessionals.
    </li>
    <li>
      You acknowledge that OPRA Data is and shall remain the property of the OPRA
      Participant on which a reported transaction took place or a reported quotation was
      entered.
    </li>
    <li>
      <strong>DISCLAIMER OF LIABILITY</strong> &mdash; NEITHER VENDOR, OPRA, OPRA&rsquo;S
      PROCESSOR NOR ANY OPRA PARTICIPANT GUARANTEES THE TIMELINESS, SEQUENCE,
      ACCURACY OR COMPLETENESS OF ANY OF THE OPRA DATA SUPPLIED TO YOU HEREUNDER
      AND NEITHER VENDOR, OPRA, OPRA&rsquo;S PROCESSOR NOR ANY OPRA PARTICIPANT
      SHALL BE LIABLE IN ANY WAY, TO YOU OR TO ANY OTHER PERSON, FOR ANY LOSS,
      DAMAGES, COST OR EXPENSE WHICH MAY ARISE FROM ANY FAILURE OF
      PERFORMANCE BY VENDOR, OPRA, OPRA&rsquo;S PROCESSOR OR ANY OPRA
      PARTICIPANT, OR FROM ANY DELAYS, INACCURACIES, ERRORS IN OR OMISSIONS OF,
      ANY OF THE OPRA DATA OR IN THE TRANSMISSION OR DELIVERY THEREOF, WHETHER
      OR NOT DUE TO ANY NEGLIGENT ACT OR OMISSION ON THE PART OF VENDOR, OPRA,
      OPRA&rsquo;S PROCESSOR OR ANY OPRA PARTICIPANT. IN NO EVENT SHALL VENDOR,
      OPRA, OPRA&rsquo;S PROCESSOR OR ANY PARTICIPANT BE LIABLE FOR ANY INCIDENTAL,
      SPECIAL, INDIRECT OR CONSEQUENTIAL DAMAGES, INCLUDING BUT NOT LIMITED TO
      LOST PROFITS, TRADING LOSSES, OR DAMAGES RESULTING FROM INCONVENIENCE OR
      LOSS OF USE OF THE SERVICE.
    </li>
    <li>
      The terms of this Agreement may be modified at any time upon notice to you. If you
      do not assent to this Agreement as modified at or prior to the time you next attempt
      to access the Service, this Agreement shall automatically be terminated. This
      Agreement as modified shall apply to your use of the Service from and after the date
      of the modification.
    </li>
    <li>
      Your receipt of the OPRA Data hereunder may be terminated at any time by you or
      by Vendor upon 30 days notice from the terminating party to the other party, and
      may be terminated immediately upon a determination by Vendor or OPRA that you
      are not in compliance with this Agreement.
    </li>
    <li>
      Nothing herein shall be deemed to prevent or restrict OPRA, OPRA&rsquo;s Processor
      or any OPRA Participant from discontinuing to furnish OPRA Data for dissemination
      or from making such changes in the speed of transmission, the characteristics of the
      electrical signals representing the OPRA Data or the manner of disseminating the
      same, as OPRA shall from time to time determine to be appropriate, with or without
      notice to you. You shall not hold OPRA, OPRA&rsquo;s Processor, or any OPRA
      Participant liable for any resulting liability, loss or damage that may arise therefrom.
    </li>
    <li>
      You agree to notify Vendor promptly of any changes in the information provided
      herein and to furnish Vendor any additional information requested by it in connection
      with your receipt of the OPRA Data.
    </li>
    <li>
      The parties acknowledge and agree that this Agreement is for the express benefit of
      OPRA, OPRA&rsquo;s Processor and each OPRA Participant.
    </li>
    <li>
      The provisions of Sections 3, 4 and 9 will survive any termination of this Agreement
      and will remain in full force and effect.
    </li>
    <li>
      All notices under this Agreement may be provided either in writing or electronically.
      All written notices to Vendor shall be sent to the Vendor&rsquo;s street address set
      forth above and all such notices to you shall be sent to the street address that you
      provide in paragraph 1. All electronic notices to Vendor shall be sent to
      Vendor&rsquo;s email address set forth above and all such notices to you shall be
      provided to you where you access the OPRA Data electronically.
    </li>
  </ol>

  <p class="mb-4">
    IF YOU AGREE TO THE TERMS AND CONDITIONS SET FORTH ABOVE, PLEASE CLICK ON THE
    &ldquo;I AGREE&rdquo; BUTTON BELOW. By clicking on the &ldquo;I Agree&rdquo; button below,
    you agree that:
  </p>
  <ol class="list-[lower-roman] pl-8 space-y-2 mb-8">
    <li>you have read and you understand all of the terms and conditions set forth above; and</li>
    <li>
      you intend to form a legally binding and valid contract under which you will be bound
      by all of the terms and conditions set forth above.
    </li>
  </ol>

  <header class="text-center my-8">
    <p class="font-bold text-lg">ADDENDUM FOR NONPROFESSIONALS</p>
    <p class="italic mt-1">(To be completed by Nonprofessional Subscribers only)</p>
  </header>

  <p class="mb-4">
    The purpose of this Addendum is to determine whether you are a &ldquo;Nonprofessional&rdquo;
    for OPRA&rsquo;s purposes. OPRA defines a &ldquo;Nonprofessional&rdquo; as a legal person
    for whom the statements set out in Section 1 of this Addendum are true.
  </p>

  <ol class="list-decimal pl-8 space-y-4 mb-4">
    <li>
      You represent and agree that the following statements are and will continue to be
      true for so long as you receive OPRA Data as a Nonprofessional:
      <ol class="list-[lower-alpha] pl-6 mt-3 space-y-3">
        <li>
          You are either a &ldquo;natural person&rdquo; (an individual human being) or a
          &ldquo;qualifying trust.&rdquo;* You are not a corporation, partnership, limited
          liability company, or other form of entity (including any form of trust that does not
          qualify as a qualifying trust). If you agree, click on &ldquo;I Agree&rdquo;.
        </li>
        <li>
          If you are a natural person, you shall use the OPRA Data solely in connection
          with your personal investment activities and the personal investment activities of
          your immediate family members** and qualifying trusts of which you are the
          trustee or custodian. If you are a qualifying trust, you shall use the OPRA Data
          solely in connection with your personal investment activities. In any case, you
          shall not use the OPRA Data in connection with any trade, business, professional
          or other commercial activities. If you agree, click on &ldquo;I Agree&rdquo;.
        </li>
        <li>
          You are not a &ldquo;Professional.&rdquo; For a natural person who works in the
          United States, a &ldquo;Professional&rdquo; is a natural person who is: (i) registered
          or qualified with the Securities and Exchange Commission, the Commodities
          Futures Trading Commission, any state securities agency, any securities
          exchange/association, or any commodities/futures contract market/association,
          (ii) engaged as an &ldquo;investment adviser,&rdquo; as that term is defined in the
          Investment Advisers Act of 1940 (whether or not registered or qualified under
          that Act); or (iii) employed by a bank or other organization exempt from
          registration under Federal and/or state securities laws to perform functions that
          would require you to be so registered or qualified if you were to perform such
          functions for an organization not so exempt. For a natural person who works
          outside of the United States, a &ldquo;Professional&rdquo; is a natural person who
          performs the same functions as someone who would be considered a
          &ldquo;Professional&rdquo; in the United States. If you agree that you are not a
          &ldquo;Professional&rdquo;, click on &ldquo;I Agree&rdquo;.
        </li>
      </ol>
    </li>
    <li>
      You agree to notify Vendor promptly if your circumstances change such that any of
      the statements in Section 1 of this Addendum would no longer be true for you.
    </li>
  </ol>

  <div class="text-sm text-gray-600 italic mt-6 space-y-3">
    <p>
      *The term &ldquo;qualifying trust&rdquo; means (a) any irrevocable or revocable trust
      (1) which has only one trustee, who is a natural person and is not receiving any
      compensation for acting as trustee and (2) of which the only current beneficiaries are
      any one or more of the trustee and the immediate family members of the trustee, and
      (b) any custodial account established under a Uniform Transfers to Minors Act or
      similar state statute (1) which has only one custodian, who is a natural person and is
      not receiving any compensation for acting as custodian, and (2) of which the
      beneficiary is a lineal descendant (a child, grandchild, etc.) of the custodian. A
      &ldquo;current beneficiary&rdquo; is a beneficiary to whom the current income or
      principal of the trust may or must then be distributed, ignoring the possible exercise of
      any then unexercised power of appointment. The term &ldquo;immediate family
      members&rdquo; is defined in the footnote to paragraph 1(b) of this Addendum.
    </p>
    <p>
      **The term &ldquo;immediate family members&rdquo; means, with reference to a
      particular natural person, the spouse of that person, that person&rsquo;s lineal
      ancestors (that is, parents, grandparents, etc.) and lineal descendants (that is,
      children, grandchildren, etc.), and the spouses (including surviving spouses) of that
      person&rsquo;s lineal ancestors and lineal descendants. The term includes step and
      adoptive relationships.
    </p>
  </div>

  <p class="text-xs text-gray-500 mt-8">12/2014</p>
</article>
